import actionTypes from '../constants/action-types';
import type { HostingPackages } from '../types/hosting-package';
import type { PayloadAction } from '../types/actions';

const hostingPackages = (
  state: HostingPackages | null = null,
  action: PayloadAction<HostingPackages>
): HostingPackages | null => {
  if (action.type === actionTypes.SET_HOSTING_PACKAGES) {
    return action.payload;
  }

  return state;
};

export default hostingPackages;
